import { useEffect, useState } from 'react';
import { workspacesApi } from '../lib/api';

// Returns the viewer's role in the workspace; null while loading or on error.
export default function useViewerRole(workspaceId) {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!workspaceId) {
      setRole(null);
      setLoading(false);
      return;
    }
    const controller = new AbortController();
    setLoading(true);
    workspacesApi
      .getMyRole(workspaceId, controller.signal)
      .then((data) => setRole(data?.role ?? null))
      .catch((err) => {
        if (err.name !== 'AbortError') setRole(null);
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [workspaceId]);

  return { role, loading };
}
